import { PropsWithChildren } from 'react';

import { MetadataFieldset } from '@/react/portainer/environments/common/MetadataFieldset/MetadataFieldset';

import { FormSection } from '@@/form-components/FormSection';

interface Props {
  showGroupInheritance?: boolean;
}

export function MoreSettingsSection({
  children,
  showGroupInheritance,
}: PropsWithChildren<Props>) {
  return (
    <FormSection title="More settings" className="ml-0" isFoldable>
      <div className="ml-8">
        {children}

        <MetadataFieldset showGroupInheritance={showGroupInheritance} />
      </div>
    </FormSection>
  );
}
